import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
const logo = require("../assets/images/logo.jpg");

function Header() {
  const location = useLocation();
  
  return (
    <Navbar expand="lg" variant="dark" className="glass-nav py-1">
      <Container fluid className="px-4">
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img src={logo} alt="Logo" height="45" width="45" className="rounded-circle shadow-sm me-3" />
          <div className="d-none d-md-block">
            <h4 className="mb-0 fw-bold text-warning" style={{ fontSize: "1.2rem" }}>
              ஸ்ரீ ஆலடி ஈஸ்வரர் சமேத சிவகாமியம்மாள் திருக்கோவில்
            </h4>
            <small className="text-light opacity-75" style={{ fontSize: "0.8rem" }}>
              ஈஞ்சார், சிவகாசி மேற்கு, விருதுநகர் - 626124
            </small>
          </div>
          <div className="d-block d-md-none">
            <h5 className="mb-0 fw-bold text-warning" style={{ fontSize: "1rem" }}>
              ஆலடி ஈஸ்வரர் கோவில்
            </h5>
          </div>
        </Navbar.Brand>
        <Nav className="ms-auto">
          <Nav.Link onClick={() => {
            localStorage.removeItem("temple_auth");
            window.location.href = "/";
          }} className="btn btn-sm btn-outline-light text-white px-3 fw-bold" style={{ borderRadius: '20px' }}>
            Logout
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
}

export default Header;
